import { createSelector } from 'reselect'

const getTeam = (teams, id) => teams.find(team => team.id === id);
export const makeGetTeam = () => createSelector(getTeam, team => team);

const getSortedActiveTeams = (teams, notifications) => teams
    .filter(team => !team.archived)
    .sort((t1, t2) => {
        if (t1.is_current) return -2;
        if (t2.is_current) return 2;

        if (!t1.name) {
            return 3;
        }

        if (!t2.name) {
            return -3;
        }

        return t1.name.toLowerCase() > t2.name.toLowerCase() ? 1 : -1;
    });
export const makeGetSortedActiveTeams = () => createSelector(getSortedActiveTeams, teams => teams);

const getActiveTeamsAndLinkedTeamsCount = (teams, linkedTeams) => getSortedActiveTeams(teams).length + (linkedTeams?.map(({ teams }) => teams).flat().length || 0);
export const makeGetActiveTeamsAndLinkedTeamsCount = () => createSelector(getActiveTeamsAndLinkedTeamsCount, count => count);

const getSortedTeams = (teams, notifications) => teams
    .sort((t1, t2) => {
        if (t1.is_current) return -2;
        if (t2.is_current) return 2;

        return t1.name.toLowerCase() > t2.name.toLowerCase() ? 1 : -1;
    });
export const makeGetSortedTeams = () => createSelector(getSortedTeams, teams => teams);

const getCurrentTeam = teams => teams?.items.find(team => team.is_current);
export const makeGetCurrentTeam = () => createSelector(getCurrentTeam, team => team);
export const makeGetCurrentTeamUrl = () => createSelector(getCurrentTeam, team => team && team.url);
export const makeGetCurrentTeamId = () => createSelector(getCurrentTeam, team => team && team.id);

const getTeamByUrl = (teams, teamUrl) => teams.items.find(team => team.url === teamUrl);
export const makeGetTeamByUrl = () => createSelector(getTeamByUrl, team => team);
